// components/ToolCard.jsx
import { Card, CardContent, CardActions, Typography, Box, Button } from '@mui/material';

const ToolCard = ({ icon, title, description, color, onClick }) => (
    <Card
        sx={{
            height: '100%',
            bgcolor: 'rgba(255,255,255,0.1)',
            backdropFilter: 'blur(5px)',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: `0px 0px 40px ${color}`,
            },
            borderRadius: 9,
        }}
    >
        <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <Box sx={{
                    bgcolor: color,
                    width: 60,
                    height: 60,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {icon}
                </Box>
            </Box>
            <Typography variant="h4" align="center" gutterBottom sx={{ color: 'white', fontWeight: 'bold' }}>
                {title}
            </Typography>
            <Typography variant="h6" align="center" sx={{ mb: 2, color: 'white', opacity: 0.9 }}>
                {description}
            </Typography>
        </CardContent>
        <CardActions sx={{ justifyContent: 'center', pb: 2 }}>
            <Button
                variant="outlined"
                size="small"
                sx={{ color: 'white', borderColor: 'white' }}
                onClick={onClick}
            >
                Learn More
            </Button>
        </CardActions>
    </Card>
);

export default ToolCard;
